module.exports = __webpack_public_path__ + "media/components/country-flag/static/mh-ab7f01db808a526be8dd32f570eb7f3a.svg";